// TODO Add links
export const footerLinks = [
  { to: '/', text: 'תקנון' },
  { to: '/', text: 'החנות הרשמית' },
  { to: '/', text: 'רכישת כרטיסים' },
  { to: '/', text: 'תקנון האתר' },
  { to: '/', text: 'מדיניות פרטיות' },
  { to: '/', text: 'חדשות' },
  { to: '/', text: 'צור/י קשר' },
  { to: '/', text: 'דרושים' },
]
